import React, { useContext } from 'react';
import _map from 'lodash/map';
import { Option, Select } from 'baseui/select';
import { useStyletron } from 'baseui';
import { CRM_APPS, AppContext } from 'commons-ui';

const useAppSelect = () => {
	const { onAppChange, app } = useContext(AppContext);

	const handleChange = (option?: Option) => {
		const appName = option?.value;
		onAppChange(CRM_APPS.filter((APP) => APP.appName === appName)[0]);
	};

	return { app, handleChange };
};

const AppSelect: React.FC<{}> = () => {
	const { app, handleChange } = useAppSelect();

	const [css] = useStyletron();

	const appOptions = _map(CRM_APPS, (APP) => ({ key: APP.displayName, value: APP.appName }));

	return (
		<div className={css({ display: 'flex', justifyContent: 'space-between', width: '30%' })}>
			<span
				className={css({
					fontSize: '18px',
					alignItems: 'center',
					fontWeight: 'bold',
					display: 'flex',
					justifyContent: 'center'
				})}>
				Selected App
			</span>
			<div
				className={css({
					width: '230px !important'
				})}>
				<Select
					options={appOptions}
					overrides={{
						ControlContainer: {
							style: ({ $theme }) => ({
								backgroundColor: $theme.colors.contentInverseTertiary
							})
						}
					}}
					labelKey='key'
					valueKey='value'
					searchable={false}
					clearable={false}
					onChange={({ option }) => handleChange(option)}
					value={[
						...(app
							? [{ key: app.displayName, value: app.appName }]
							: [{ key: CRM_APPS[0].displayName, value: CRM_APPS[0].appName }])
					]}
				/>
			</div>
		</div>
	);
};

export default AppSelect;
